<script>
  import Notifications from '../components/Notifications.svelte';
  import { client } from 'root/api/index.js';
  import InfiniteScroll from '../components/DataTable/InfiniteScroll.svelte';
  import { displayTimeAgo, mergeNotificationArr } from 'components/Helper.js';
  import Loader from '../components/Loader.svelte';
  import { onMount, getContext } from 'svelte';
  import { unreadCount } from '../stores/unreadCount.js';
  const showDialog = getContext('showDialog');
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let notificationData = [];
  let isPaginationLoading = false;
  const getNotificationList = () => {
    isPaginationLoading = true;
    client
      .notificationList(pageSize, pageNumber)
      .then((response) => {
        if (response.data.pagination.pageNumber == 1) {
          notificationData = [];
        }
        isPaginationLoading = false;
        notificationData = mergeNotificationArr(notificationData, response.data.payload);
        totalPages = response.data.pagination.totalPage;
        filterUnreadList(notificationData);
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const filterUnreadList = () => {
    return false;
    let arr = [];
    notificationData.forEach((value, index) => {
      arr = arr.concat(
        value.values
          .filter((item) => item.read == 0)
          .map((item) => {
            return { id: item.notificationUserId };
          }),
      );
    });
    if (arr.length > 0) {
      unreadNotification(arr);
    }
  };
  const unreadNotification = (arr) => {
    client
      .notificationRead({ notifications: arr })
      .then((response) => {
        unreadCount.set(0);
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  onMount(() => {
    getNotificationList();
    unreadCount.set(0);
  });
</script>

<div class="d-flex flex-column h-100">
  <div class="px-3 pt-3 pb-0">
    <h2 class="page-title">Notifications</h2>
  </div>

  <div class="page-content p-3">
    <div class=" card-content bg-white h-100 d-flex flex-column">
      {#if notificationData.length <= 0 && !isPaginationLoading}
        <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
          <svg
            fill="#787e8d"
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="40"
            viewBox="0 0 512 512"
            width="50"
            xmlns="http://www.w3.org/2000/svg"
            ><path
              d="m450.201 407.453c-1.505-.977-12.832-8.912-24.174-32.917-20.829-44.082-25.201-106.18-25.201-150.511 0-.193-.004-.384-.011-.576-.227-58.589-35.31-109.095-85.514-131.756v-34.657c0-31.45-25.544-57.036-56.942-57.036h-4.719c-31.398 0-56.942 25.586-56.942 57.036v34.655c-50.372 22.734-85.525 73.498-85.525 132.334 0 44.331-4.372 106.428-25.201 150.511-11.341 24.004-22.668 31.939-24.174 32.917-6.342 2.935-9.469 9.715-8.01 16.586 1.473 6.939 7.959 11.723 15.042 11.723h109.947c.614 42.141 35.008 76.238 77.223 76.238s76.609-34.097 77.223-76.238h109.947c7.082 0 13.569-4.784 15.042-11.723 1.457-6.871-1.669-13.652-8.011-16.586zm-223.502-350.417c0-14.881 12.086-26.987 26.942-26.987h4.719c14.856 0 26.942 12.106 26.942 26.987v24.917c-9.468-1.957-19.269-2.987-29.306-2.987-10.034 0-19.832 1.029-29.296 2.984v-24.914zm29.301 424.915c-25.673 0-46.614-20.617-47.223-46.188h94.445c-.608 25.57-21.549 46.188-47.222 46.188zm60.4-76.239c-.003 0-213.385 0-213.385 0 2.595-4.044 5.236-8.623 7.861-13.798 20.104-39.643 30.298-96.129 30.298-167.889 0-63.417 51.509-115.01 114.821-115.01s114.821 51.593 114.821 115.06c0 .185.003.369.01.553.057 71.472 10.25 127.755 30.298 167.286 2.625 5.176 5.267 9.754 7.861 13.798z"
            /></svg
          >
          <span class="color-lead font-size-18 mt-3 d-block"
            >You don't have any notification yet</span
          >
        </div>
      {/if}
      <div class="page-content p-3">
        {#each notificationData as item, itemkey}
          <div class="d-flex flex-column mb-3">
            <span class="font-size-13 color-blue mb-3">{item.label}</span>
            {#each item.values as itemData, itemdatakey}
              <Notifications
                item={itemData}
                url={itemData.url}
                title={itemData.message}
                timeAgoStr={itemData.timeAgoStr}
              />
            {/each}
          </div>
        {/each}
        <InfiniteScroll
          threshold={300}
          hasMore={pageNumber < totalPages}
          isLoading={isPaginationLoading}
          on:loadMore={() => {
            pageNumber = pageNumber + 1;
            getNotificationList();
          }}
        >
          <div
            class="scroll-spinner-container d-flex justify-content-center
			  align-items-center"
          >
            <Loader Style="loader-block" />
          </div>
        </InfiniteScroll>
      </div>
    </div>
  </div>
</div>
